/**
 * See `projects/ftr-web/src/assets/images/svgs/README.md` for instructions on how to add new icons
 */
export const ICONS = {
  AccessTranscriptJobs: 'access_transcript_jobs',
  AccountCircle: 'account_circle',
  Add: 'add',
  AddCircle: 'add_circle',
  AddPerson: 'add_person',
  Agent: 'agent',
  Annotate: 'annotate',
  Apple: 'apple',
  ApproachingDue: 'approaching_due',
  Archive: 'archive',
  ArrowDown: 'arrow_down',
  ArrowLeft: 'arrow_left',
  ArrowRight: 'arrow_right',
  ArrowUp: 'arrow_up',
  Assignment: 'assignment',
  AssignmentReturn: 'assignment_return',
  AssignmentTurnedIn: 'assignment_turned_in',
  AudioOrder: 'audio_order',
  AuditLog: 'audit_log',
  Automation: 'automation',
  Autoscroll: 'autoscroll',
  AutoscrollOff: 'autoscroll_off',
  AwaitingApproval: 'awaiting_approval',
  AwaitingApprovalLine: 'awaiting_approval_line',
  AwaitingFulfillment: 'awaiting_fulfillment',
  Backward30: 'backward_30',
  Backward5: 'backward_5',
  BarGraphHorizontal: 'bar_graph_horizontal',
  BarGraphVertical: 'bar_graph_vertical',
  BrokenImage: 'broken_image',
  Billing: 'billing',
  BlankEvent: 'blank_event',
  CalendarDay: 'calendar_day',
  CardChart: 'card_chart',
  Case: 'case',
  Cart: 'cart',
  Checkmark: 'checkmark',
  CheckmarkCircle: 'checkmark_circle',
  CheckmarkCircleLine: 'checkmark_circle_line',
  ChevronDown: 'chevron_down',
  ChevronLeft: 'chevron_left',
  ChevronRight: 'chevron_right',
  ChevronUp: 'chevron_up',
  Clock: 'clock',
  Close: 'close',
  CloseCircle: 'close_circle',
  CloseCircleLine: 'close_circle_line',
  Content: 'content',
  ContentLicense: 'content_license',
  Copy: 'copy',
  CourtLocation: 'court_location',
  CourtMonitoring: 'court_monitoring',
  Courthouse: 'courthouse',
  CourthouseLine: 'courthouse_line',
  Courtroom: 'courtroom',
  CourtroomLine: 'courtroom_line',
  CourtroomCalendar: 'courtroom_calendar',
  CreditCard: 'credit_card',
  Debug: 'debug',
  Delete: 'delete',
  Department: 'department',
  DesktopDeepLink: 'desktop_deep_link',
  Document: 'document',
  DollarSign: 'dollar_sign',
  Door: 'door',
  Download: 'download',
  DownloadDesktopApp: 'download_desktop_app',
  DownloadRecording: 'download_recording',
  DownloadText: 'download_text',
  Drag: 'drag',
  DragIndicator: 'drag_indicator',
  Edit: 'edit',
  Email: 'email',
  ErrorCircleLine: 'error_circle_line',
  ErrorCircleSolid: 'error_circle_solid',
  ExitFullscreen: 'exit_fullscreen',
  Export: 'export',
  ExternalAccess: 'external_access',
  Facebook: 'facebook',
  Favorites: 'favorites',
  Filter: 'filter',
  Folder: 'folder',
  FolderOpenLive: 'folder_open_live',
  FolderOpenStop: 'folder_open_stop',
  FootPedal: 'foot_pedal',
  Forward30: 'forward_30',
  Forward5: 'forward_5',
  Forum: 'forum',
  Fullscreen: 'fullscreen',
  FullscreenView: 'fullscreen_view',
  Gavel: 'gavel',
  GlobalAdmin: 'global_admin',
  Google: 'google',
  Grid: 'grid',
  Hearing: 'hearing',
  HelpCircleLine: 'help_circle_line',
  HelpCircleSolid: 'help_circle_solid',
  Historical: 'historical',
  Home: 'home',
  HomeOutline: 'home_outline',
  Inactive: 'inactive',
  InfoCircleLine: 'info_circle_line',
  InfoCircleSolid: 'info_circle_solid',
  InProgress: 'in_progress',
  InReview: 'in_review',
  Judge: 'judge',
  JumpTo: 'jump_to',
  Keyboard: 'keyboard',
  Language: 'language',
  LargerView: 'larger_view',
  LineGraph: 'line_graph',
  Link: 'link',
  LinkOff: 'link_off',
  ListAlt: 'list_alt',
  Livestream: 'livestream',
  Location: 'location',
  LockLive: 'lock_live',
  LockStop: 'lock_stop',
  Locked: 'locked',
  Logo: 'logo',
  Logout: 'logout',
  Menu: 'menu',
  MicLive: 'mic_live',
  MicStop: 'mic_stop',
  Microphone: 'microphone',
  MicrophoneLine: 'microphone_line',
  Microsoft: 'microsoft',
  Minus: 'minus',
  MinusCircle: 'minus_circle',
  MinusCircleLine: 'minus_circle_line',
  More: 'more',
  MoreHorizontal: 'more_horizontal',
  MoveDown: 'move_down',
  MoveUp: 'move_up',
  Multichannel: 'multichannel',
  MyOrders: 'my_orders',
  NavigateDown: 'navigate_down',
  NavigateUp: 'navigate_up',
  NoAccess: 'no_access',
  NotInSession: 'not_in_session',
  NotLocked: 'not_locked',
  Off: 'off',
  OpenInNew: 'open_in_new',
  OrderTranscript: 'order_transcript',
  Pause: 'pause',
  PauseCircle: 'pause_circle',
  People: 'people',
  PeopleLine: 'people_line',
  Person: 'person',
  Phone: 'phone',
  PieChart: 'pie_chart',
  Pilot: 'pilot',
  Pin: 'pin',
  Play: 'play',
  PlayCircle: 'play_circle',
  PlayerMenu: 'player_menu',
  RadioButtonSelected: 'radio_button_selected',
  RealtimeOrder: 'realtime_order',
  RecordLarge: 'record_large',
  RecordingVault: 'recording_vault',
  Recorder: 'recorder',
  RecordingRequest: 'recording_request',
  Recordings: 'recordings',
  Reload: 'reload',
  Remote: 'remote',
  Requests: 'requests',
  Restricted: 'restricted',
  RestoreVersion: 'restore_version',
  Resubmission: 'resubmission',
  Sandbox: 'sandbox',
  Search: 'search',
  Segment: 'segment',
  Sell: 'sell',
  SendToWaitingRoom: 'send_to_waiting_room',
  Settings: 'settings',
  Share: 'share',
  SharedRecordings: 'shared_recordings',
  SmallerView: 'smaller_view',
  Solo: 'solo',
  Sort: 'sort',
  SortAscending: 'sort_ascending',
  SortDescending: 'sort_descending',
  Speaker: 'speaker',
  SpeechToText: 'speech_to_text',
  SplitView: 'split_view',
  SplitView3070: 'split_view_30_70',
  SplitView7030: 'split_view_70_30',
  StepArrow: 'step_arrow',
  StopCircle: 'stop_circle',
  Storage: 'storage',
  TableChart: 'table_chart',
  Tablet: 'tablet',
  TheRecord: 'the_record',
  ThumbsDown: 'thumbs_down',
  ThumbsUp: 'thumbs_up',
  Timezone: 'timezone',
  Tip: 'tip',
  ToggleOff: 'toggle_off',
  ToggleOn: 'toggle_on',
  Transcriber: 'transcriber',
  Transcript: 'transcript',
  TranscriptJobs: 'transcript_jobs',
  TranscriptOrder: 'transcript_order',
  TrmRepositories: 'trm_repositories',
  Turnaround: 'turnaround',
  Unlocked: 'unlocked',
  Unpin: 'unpin',
  Upload: 'upload',
  UploadAndPlay: 'upload_and_play',
  UserAccess: 'user_access',
  UsersLine: 'users_line',
  Verify: 'verify',
  VerifyLine: 'verify_line',
  Video: 'video',
  VideoOff: 'video_off',
  VisibilityOff: 'visibility_off',
  VisibilityOffLine: 'visibility_off_line',
  VisibilityOn: 'visibility_on',
  VisibilityOnLine: 'visibility_on_line',
  VolumeDown: 'volume_down',
  VolumeOff: 'volume_off',
  VolumeUp: 'volume_up',
  Warning: 'warning',
  WarningLine: 'warning_line',
  WaveformOff: 'waveform_off',
} as const
export type Icon = keyof typeof ICONS

export enum CardIcon {
  Amex = 'amex',
  AmexGrey = 'amex_grey',
  Diners = 'diners',
  DinersClub = 'diners_club',
  DinersGrey = 'diners_grey',
  Discover = 'discover',
  DiscoverGrey = 'discover_grey',
  Jcb = 'jcb',
  JcbGrey = 'jcb_grey',
  Mastercard = 'mastercard',
  MastercardGrey = 'mastercard_grey',
  Visa = 'visa',
  VisaGrey = 'visa_grey',
}
